// postMessage contract for the dashboard → hosted-page live preview iframe.
// These messages flow directly between the dashboard window and the preview
// iframe — they never pass through the external hosted script, so they are
// NOT part of the DONATE production contract.
export const HOSTED_PREVIEW_ENTITY = 'CHARITYSTACK';

// iframe → parent: PreviewHost has mounted and can receive data
export const HOSTED_PREVIEW_READY = 'CS_HOSTED_PREVIEW_READY';

// parent → iframe: full previewData payload (sent on ready + every edit)
export const HOSTED_PREVIEW_DATA = 'CS_HOSTED_PREVIEW_DATA';
